export default __webpack_public_path__ + "static/media/check-in-circle-gradient.cb190eaf.svg";